import { Slide } from "@jelly/lesson";

import { task as task02 } from "../../../../../task/course-02/lesson-25/task-02";

const task: Slide = {
  title: "Connect Elements to correct answers.",
  description: "Drag a line from point to point.",
  layout: {
    type: "simple",
    options: {
      components: {
        variant: "__task__",
        data: {
          id: task02.id,
        },
      },
    },
  },
};

export default task;
